
import React, { useState } from 'react';
import MonacoEditor from '@monaco-editor/react';
import CompletionPopup from '../completion-popup';
import { serverURL } from '../../config/urls';
import { logEvent } from '@firebase/analytics';
import {analytics} from '../../config/firebase-logging';
import { useCareerContext } from '../career-context';

export function ForLoops() {
    const {
        isPopupOpen,
        setIsPopupOpen,
        startConfetti
    } = useCareerContext();
    const options = { scrollbar: { alwaysConsumeMouseWheel: false, }, scrollBeyondLastLine: false, minimap: { enabled: false, } }

    const [code, setCode] = useState(
`def count_word(text, word):
    # Fill in the code
    count = 0
    for i in range():
        if text[:] == word:
            count += 1
    return count`
    );
    const [output, setOutput] = useState('');

    function handleEditorChange(newValue, event) {
        setCode(newValue);
    }

    async function runCode() {
        if (process.env.REACT_APP_ENVIRONMENT === "production") {
            logEvent(analytics, 'career_interaction')
        }
        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ code }),
        };
        const response = await fetch(serverURL + "/for_loops", requestOptions);
        const result = await response.json();
        if (result.error) {
            setOutput(result.error);
        } else if (result.verdict === "Fail") {
            setOutput(`Test count_word("${result.test[0]}", "${result.test[1]}") failed.\nExpected: ${result.expected}, got ${result.result} instead`)
        } else {
            setOutput("");
            setIsPopupOpen(true);
            startConfetti();
        }
    }

    function hidePopup() {
        setIsPopupOpen(false);
    }


    return (
        <>
            {isPopupOpen && <CompletionPopup title="Great Job!" message="That was a tough one, but you got it!" hidePopup={hidePopup} />}

            <h2 className='blue'>Building a Word Counter</h2>
            <p>
                Your successful results in the previous tasks has earned you quite a reputation as a SWE! Now Grammarly has contacted you to build a word counter to help users avoid over-reusing words. Complete the <code>count_word(text, word)</code> function, which takes in a string <code>text</code> and a string <code>word</code> and returns the number of times <code>word</code> appears in <code>text</code>. The word can appear in the middle of other words.
            </p>
            <p>Examples</p>
            <ul>
                <li><code>count_word(<span className='string'>"She sells seashells by the seashore"</span>, <span className='string'>"sea"</span>)</code> returns <code>2</code></li>
                <li><code>count_word(<span className='string'>"Peter Piper picked a peck of pickled peppers, a peck of pickled peppers Peter Piper picked."</span>, <span className='string'>"pick"</span>)</code> returns <code>4</code></li>
                <li><code>count_word(<span className='string'>"do you play chess"</span>, <span className='string'>"checkers"</span>)</code> returns <code>0</code></li>

            </ul>

            <div className='row' style={{ alignItems: "flex-start" }}>
                <div style={{ width: (output) ? "50%" : "100%" }}>
                    <div className='editor-padding'></div>
                    <MonacoEditor theme='vs-dark' language='python' height="200px" value={code} onChange={handleEditorChange} options={options} />
                    <button className='primary-btn blue-bg' style={{ marginTop: "5px" }} onClick={runCode}>Submit</button>
                </div>
                
                {output && <pre className='output' style={{ height: "200px" }}>{output}</pre>}

            </div>
        </>
    );
}

